<template>
  <div class="image-area">
    <img :src="murl" :class="{hidden: !loaded}" />
  </div>
</template>

<script>
export default {
  props: {
    url: String
  },
  data () {
    return {
      loaded: false,
      murl: ''
    }
  },
  created () {
    if(this.url) {
      this.murl = this.$k.imagebase + this.url
    }
  },
  mounted () {
    if(this.url){
      this.preload()
    }
    
  },
  methods: {
    preload: async function () {
      this.loaded = false
      this.murl = this.$k.imagebase + this.url
      await this.$k.waitfor(300)
      this.loaded = true
    },
    justSwitch: async function () {
      this.loaded = false
      await this.$k.waitfor(300)
      this.murl = this.$k.imagebase + this.url
      await this.$k.waitfor(400)
      this.loaded = true
    }
  },
  watch:{
    url() {
      if(this.murl === ''){
        this.preload()
      }
      else {
        this.justSwitch()
      }
    }
  }
}
</script>

<style scoped>
.image-area{
  cursor:zoom-in;
  display:inline-block;
}

.image-area img{
  max-width:60vw;
  max-height:calc(98vh - 80px);
  display:block;
  opacity:1;
  transition: opacity 0.3s linear;
}

.image-area img.hidden{
  opacity:0;
}

.image-area.static img{
  max-width:60vw;
  max-height:40vh;
  display:block;
}
</style>